export const dotsOfHistory = (intPercentage: number) => {
  const colors = [];
  for (let i = 0; i < 5; i++) {
    if (intPercentage >= 99) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#ffffff',
          percentage: 10,
        },
        {
          color: '#ffffff',
          percentage: 25,
        },
        {
          color: '#ffffff',
          percentage: 50,
        },
        {
          color: '#ffffff',
          percentage: 75,
        },
        {
          color: '#ffffff',
          percentage: 99,
        }
      );
      return colors;
    }
    if (intPercentage >= 75) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#ffffff',
          percentage: 10,
        },
        {
          color: '#ffffff',
          percentage: 25,
        },
        {
          color: '#ffffff',
          percentage: 50,
        },
        {
          color: '#ffffff',
          percentage: 75,
        },
        {
          color: '#409F85',
          percentage: 99,
        }
      );
      return colors;
    }
    if (intPercentage >= 50) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#ffffff',
          percentage: 10,
        },
        {
          color: '#ffffff',
          percentage: 25,
        },
        {
          color: '#ffffff',
          percentage: 50,
        },
        {
          color: '#409F85',
          percentage: 75,
        },
        {
          color: '#409F85',
          percentage: 99,
        }
      );
      return colors;
    }
    if (intPercentage >= 25) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#ffffff',
          percentage: 10,
        },
        {
          color: '#409F85',
          percentage: 25,
        },
        {
          color: '#409F85',
          percentage: 50,
        },
        {
          color: '#409F85',
          percentage: 75,
        },
        {
          color: '#409F85',
          percentage: 99,
        }
      );
      return colors;
    }
    if (intPercentage >= 10 && intPercentage < 25) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#409F85',
          percentage: 10,
        },
        {
          color: '#409F85',
          percentage: 25,
        },
        {
          color: '#409F85',
          percentage: 50,
        },
        {
          color: '#409F85',
          percentage: 75,
        },
        {
          color: '#409F85',
          percentage: 99,
        }
      );
      return colors;
    }
    if (intPercentage < 10) {
      colors.push(
        {
          color: '#ffffff',
          percentage: 1,
        },
        {
          color: '#409F85',
          percentage: 10,
        },
        {
          color: '#409F85',
          percentage: 25,
        },
        {
          color: '#409F85',
          percentage: 50,
        },
        {
          color: '#409F85',
          percentage: 75,
        },
        {
          color: '#409F85',
          percentage: 99,
        }
      );
      return colors;
    }
  }
};
